import { TimetableParams } from '../types/Input'
import { TimetableRequestOrigin } from '../types/States'

export type UpdateTimetable = {
  type: 'UPDATE_TIMETABLE'
}
export const UPDATE_TIMETABLE = 'UPDATE_TIMETABLE'
export const updateTimetable = (): UpdateTimetable => ({
  type: UPDATE_TIMETABLE,
})

export type SetTimetableError = {
  type: 'TIMETABLE_ERROR'
  payload: string
}
export const TIMETABLE_ERROR = 'TIMETABLE_ERROR'
export const timetableError = (error: string): SetTimetableError => ({
  type: TIMETABLE_ERROR,
  payload: error,
})

export type StartFetchTimetable = {
  type: 'START_FETCHING_TIMETABLE'
  payload: TimetableRequestOrigin
}
export const START_FETCHING_TIMETABLE = 'START_FETCHING_TIMETABLE'
export const startFetchingTimetable = (
  requestOrigin: TimetableRequestOrigin
): StartFetchTimetable => ({
  type: START_FETCHING_TIMETABLE,
  payload: requestOrigin,
})

export type UpdateLatestPartialTimetableFailures = {
  type: 'UPDATE_LATEST_PARTIAL_TIMETABLE_FAILURES'
  payload: { shiftId: string; isUsedForDriving: boolean; failedParts: TimetableParams[] }
}
export const UPDATE_LATEST_PARTIAL_TIMETABLE_FAILURES = 'UPDATE_LATEST_PARTIAL_TIMETABLE_FAILURES'
export const updateLatestPartialTimetableFailures = (
  shiftId: string,
  isUsedForDriving: boolean,
  failedParts: TimetableParams[]
): UpdateLatestPartialTimetableFailures => ({
  type: UPDATE_LATEST_PARTIAL_TIMETABLE_FAILURES,
  payload: { shiftId, isUsedForDriving, failedParts },
})

type OpenModal = {
  type: 'OPEN_MODAL'
  payload: {
    isOpen: boolean
    usedTimetableParams: Array<TimetableParams>
    pendingRequestOrigin: TimetableRequestOrigin | null
  }
}
export const OPEN_MODAL = 'OPEN_MODAL'
export const openModal = (payload: {
  isOpen: boolean
  usedTimetableParams: Array<TimetableParams>
  pendingRequestOrigin: TimetableRequestOrigin | null
}): OpenModal => ({
  type: OPEN_MODAL,
  payload,
})

export type CheckInModal = {
  type: 'CHECK_IN_MODAL'
  payload: boolean
}
export const CHECK_IN_MODAL = 'CHECK_IN_MODAL'
export const checkInModal = (checked: boolean): CheckInModal => ({
  type: CHECK_IN_MODAL,
  payload: checked,
})

export type TimetableAction =
  | UpdateTimetable
  | SetTimetableError
  | StartFetchTimetable
  | UpdateLatestPartialTimetableFailures
  | OpenModal
  | CheckInModal
